import DestinationItem from '../Destinations/DestinationItem';
import { Country } from '../../data/countryData';

interface ContinentProps {
  continent: {
    continent: string;
    countries: Country[];
  };
}

const ContinentComponent = ({ continent }: ContinentProps) => {
  return (
    <div className="mb-6">
      <div className="rounded-lg bg-white mx-auto flex flex-col p-4">
        <h2 className="text-2xl font-semibold text-gray-800 mb-6 md:text-left text-center">
          {continent.continent}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {continent.countries.map((country: Country) => (
            <DestinationItem key={country.id} country={country} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContinentComponent;
